import backendURLs from '~/misc/backendURLs';

export default (axios, id) => {
  return axios
    .get(`${backendURLs.creators}/${id}/recommended`, {
      params: {
        query: {
          $where: { 'profile.handle': { $ne: process.env.FOUND_US_HANDLE } }
        }
      }
    })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
